import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/ApiServices';
import { tokenService } from '../utils/token';

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
  const initAuth = async () => {
    const token = tokenService.getToken();
    const savedUser = tokenService.getUser();

    if (token && savedUser) {
      setUser(savedUser);

      // try {
      //   const freshUser = await authAPI.getCurrentUser();
      //   setUser(freshUser);
      //   tokenService.saveUser(freshUser);
      // } catch {
      //   tokenService.removeToken();
      //   setUser(null);
      // }
    }

    setIsLoading(false);
  };

  initAuth();
}, []);


 const login = async (email, password) => {
  const response = await authAPI.login({ email, password });

  tokenService.setTokens(
    response.tokens.accessToken,
    response.tokens.refreshToken
  );

  tokenService.saveUser(response.user);
  setUser(response.user);
};



  const logout = () => {
    tokenService.removeToken();
    setUser(null);
  };

  const role = user?.role?.toLowerCase() || '';

  const isAdmin = role === 'admin';

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};